export const tableOption = {
  border: true,
  delBtn: false,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  searchMenuSpan: 6,
  searchSize: 'mini',
  selection: false,
  menu: true,
  menuWidth: 150,
  addBtn: false,
  editBtn: false,
  viewBtn: false,
  header: true,
  columnBtn: false,
  searchShowBtn: false,
  props: {
    label: 'label',
    value: 'value',
  },
  column: [
    {
      label: '译员ID',
      labelWidth: 60,
      prop: 'trId',
      row: true,
      // search: true,
      // searchLabelWidth: 60,
      // searchSpan: 6,
      editDisabled: true,
      rules: [
        {
          trigger: 'blur',
        },
      ],
      span: 24,
    },
    {
      label: '昵称',
      labelWidth: 110,
      prop: 'nickName',
      row: true,
      addDisplay: false,
      editDisplay: false,
    },
    {
      label: '签约领域',
      prop: 'industry',
      slot: true,
      row: true,
      overHidden: true,
    },
  ],
};
